/**
 * Custom Next/Image loader — strategia PASSTHROUGH GLOBALE.
 *
 * <p><strong>BUG-FIX next-image-404-after-custom-loader:</strong>
 * Quando in {@code next.config.mjs} settiamo
 * {@code images.loader = "custom"} + {@code images.loaderFile = ...}
 * Next.js DISABILITA completamente l'endpoint built-in
 * {@code /_next/image}. Il loader diventa l'unico modo per generare
 * URL immagine, e qualunque ritorno verso {@code /_next/image?url=...}
 * resulta in un 404 a runtime (DevTools Network: 404 per
 * {@code /logo.png}, per {@code img.youtube.com/...}, ecc.).</p>
 *
 * <p>Pre-fix il loader faceva passthrough SOLO per gli host CMS e usava
 * {@code /_next/image} come fallback per locali ed esterni — ma quel
 * fallback non esiste piu', da cui il 404.</p>
 *
 * <p><strong>Strategia attuale: passthrough globale.</strong> Il browser
 * fetcha sempre l'origine direttamente:
 * <ul>
 *   <li>path locali ({@code /logo.png}, {@code /hero-apertura.jpg}) →
 *       fetched dal CDN Next come asset statici;</li>
 *   <li>URL CMS ({@code cms.ccpascal.cloud}) → fetched dal backend (era
 *       il fix originale per i 500 del proxy);</li>
 *   <li>URL esterni (thumb YouTube su {@code i.ytimg.com}, ecc.) →
 *       fetched dall'origine diretta.</li>
 * </ul></p>
 *
 * <p><strong>Trade-off accettato:</strong> niente conversione
 * AVIF/WebP automatica per nessun asset. Mitigato dal fatto che
 * (a) i logo sono PNG piccoli; (b) le thumb YT sono gia' JPG ottimizzati
 * da YouTube; (c) le foto CMS dipendono dalla config del backend.</p>
 *
 * <p>Se in futuro il backend CMS espone un endpoint resize
 * ({@code /api/media/{id}?w=640&format=webp}) si puo' ampliare il loader
 * per passare {@code width} e {@code quality} come query params solo per
 * gli host CMS — il branching va re-aggiunto qui.</p>
 *
 * <p>{@code width} e {@code quality} restano nella firma per
 * compatibilita' con il contract Next/Image, ma sono ignorati: l'origine
 * serve sempre la versione originale.</p>
 */

interface LoaderArgs {
  src: string;
  width: number;
  quality?: number;
}

export default function defaultLoader({ src }: LoaderArgs): string {
  return src;
}
